import type React from 'react';

export enum VideoLength {
  FULL_8S = '8',    // 8-second full story (1 segment)
  FULL_16S = '16',  // 16-second full story (2 segments)
  FULL_24S = '24',  // 24-second full story (3 segments)
}

export enum StoryStructure {
  HOOK_TO_END = 'hook_to_end',        // Powerful hook that keeps viewers watching
  DRAMATIC_TWIST = 'dramatic_twist',   // Dramatic plot twist
  EMOTIONAL_JOURNEY = 'emotional',     // Emotional journey
  COMEDY_BUILDUP = 'comedy',          // Comedy buildup
  MYSTERY_REVEAL = 'mystery',         // Mystery and reveal
  TUTORIAL_STEPS = 'tutorial',        // Step-by-step tutorial
  BEFORE_AFTER = 'before_after',      // Before/After transformation
  CHALLENGE_RESULT = 'challenge',     // Challenge and result
  FACTS_SURPRISE = 'facts',           // Surprising facts
  STORY_LOOP = 'loop',                // Loop story structure
}

export interface StoryInputFormProps {
  onGenerate: (topic: string, length: VideoLength, structure: StoryStructure) => void;
  isLoading: boolean;
}

export interface ScriptDisplayProps {
  script: string;
  onGenerateVideo: () => void;
  isGeneratingVideo: boolean;
}

export interface VideoDisplayProps {
    videoUrl: string | null;
    isGeneratingVideo: boolean;
    videoError: string | null;
}

export interface LayoutProps {
    children: React.ReactNode;
}

export interface VideoSegment {
    segmentNumber: number;
    duration: number; // Always 8 seconds
    scriptContent: string;
    videoUrl?: string;
    transition?: string; // Transition text to next segment
}

export interface FullStoryVideo {
    totalDuration: number; // 8, 16, or 24 seconds
    segments: VideoSegment[];
    title: string;
    isSeamless: boolean; // Indicates if segments connect smoothly
}
